import React from "react";
import { Button } from "react-bootstrap";
import { FaArrowLeftLong } from "react-icons/fa6";

export default function CommonCardHeader({
    title,
    onBack,
    backLabel = "Back",
    onAction,
    actionLabel,
    actionVariant = "warm",
    className = "",
}) {
    return (
        <div className={`common-card-header ${className}`.trim()}>
            <div className="common-card-header__text">
                <span className="common-card-header__accent" />
                <h2 className="common-card-header__title">{title}</h2>
            </div>

            <div className="common-card-header__actions">
                {onAction && actionLabel ? (
                    <Button
                        size="sm"
                        onClick={onAction}
                        className={`common-card-header__btn common-card-header__btn--${actionVariant}`}
                    >
                        {actionLabel}
                    </Button>
                ) : null}

                {onBack ? (
                    <Button
                        variant="outline-secondary"
                        size="sm"
                        onClick={onBack}
                        className="common-card-header__btn common-card-header__btn--back"
                    >
                        <FaArrowLeftLong /> {backLabel}
                    </Button>
                ) : null}
            </div>
        </div>
    );
}